// extracted by mini-css-extract-plugin
module.exports = {"loginLogo":"forgetClient_loginLogo_330Mk","loginButton":"forgetClient_loginButton_1ciAr","form":"forgetClient_form_6nLss"};